var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"pill":"","block":"","variant":"light"},on:{"click":function($event){return _vm.toDashboard()}}},[_vm._v(_vm._s(_vm.$t('navigate.to.dashboard')))])}
var staticRenderFns = []

export { render, staticRenderFns }